import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

const Input = ({
  error,
  className,
  autoComplete = 'off',
  innerRef,
  ...props
}) => {
  return (
    <div
      className={cn({
        [styles.wrapper]: true,
        [className]: className,
        [styles.error]: error,
      })}
    >
      <input
        className={cn('text-s', styles.input)}
        autoComplete={autoComplete}
        {...props}
        ref={innerRef}
      />
      {error && <span className={cn('text-xs', styles.errorMsg)}>{error}</span>}
    </div>
  );
};

export default Input;
